module.exports = __webpack_public_path__ + "b0ef9506d6d4549ba46624114fa40cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/07_LC_04.png
// module id = 107
// module chunks = 0